/* eslint-disable react-hooks/exhaustive-deps */
import notify from "devextreme/ui/notify";
import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { axios } from "../../../common";
import "./style.scss";

export default function ApprovePage() {
  const { token } = useParams();

  const handleCallApprove = async (payload) => {
    const { data } = await axios.get(`/Approve/?token=${payload}`);
    notify(data.message, data.msgType, 3000);
  };

  const hanldeValidateToken = async (payload) => {
    const splitToken = payload.split(";");
    const overtimeCase = "3";

    if (splitToken[0] !== overtimeCase) {
      handleCallApprove(token);
      return;
    }
    const overtimeOid = splitToken[1];
    const approvalType = splitToken[3];
    const APPROVED = "3";
    if (approvalType !== APPROVED) {
      const { data: overtimeData } = await axios.get(
        `/OvertimeRegistration(${overtimeOid})?$expand=Employee`
      );
      if (!overtimeData) return;
      try {
        const { data } = await axios.post("ValidateTotalHours", {
          ...overtimeData,
          IsApproval: true,
        });
        if (data) {
          // eslint-disable-next-line no-restricted-globals
          if (confirm(data.message)) {
            handleCallApprove(token);
          }
        } else {
          handleCallApprove(token);
        }
      } catch (error) {
        notify(error.response.data.message, error.response.data.msgType, 3000);
      }
    }
  };

  useEffect(() => {
    hanldeValidateToken(token);
  }, [token]);

  return (
    <React.Fragment>
      <div className={"section section-not-found"}>
        <div className={"section-heading"}>
          {/* <h4 className={"section-title"}>NOT FOUND</h4> */}
        </div>
        <div className={"section-body"}>
          <h4>Progress Request</h4>

          <p>
            You can go back to our
            <Link to="/home"> Homepage.</Link>
          </p>
          {/* <img src="/assets/images/bg-welcome.png" alt="" /> */}
        </div>
      </div>
    </React.Fragment>
  );
}
